import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

export const LogoutButton: React.FC = () => {
  const { logout } = useAuth0();

  return (
    <button
      onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
      className="text-gray-700 hover:text-gray-900 font-medium transition-colors"
    >
      Log Out
    </button>
  );
};
